module.exports = __webpack_public_path__ + "img/Icon User-friendly.bff66aa2.svg";